import {myEnrollmentsApi} from '@/api/my-enrollments.api.js'
import {enrollmentFilterStates} from '@/constants/enrollments.js'
import {useQuerying} from '@/composables/use-querying.js'
import {useProvider} from '@/composables/use-provider.js'

/**
 * Helper composable for enrollments querying
 */
export function useEnrollmentsQuerying() {

  //Provider detection
  const {currentProvider} = useProvider()

  //Enrollment querying
  const {
    items: enrollments,
    total: totalEnrollments,
    queryItems: queryEnrollments,
    loadItems: loadEnrollments,
    loadMoreItems: loadMoreEnrollments,
    isLoadingItems: isLoadingEnrollments,
    isLoadingMoreItems: isLoadingMoreEnrollments,
    hasLoadedAllItems: hasLoadedAllEnrollments,
    sort,
    filter,
    search,
    limit,
    changeSort,
    changeSearch,
    changeFilter,
    changeLimit,
  } = useQuerying({
    handler: params => myEnrollmentsApi.query(params),
    sort: '-lastMessageSentAt',
    limit: 10,
    filter: {
      provider: currentProvider.value,
      state: enrollmentFilterStates.ACTIVE,
    },
  })

  //Expose interface
  return {
    enrollments,
    totalEnrollments,
    queryEnrollments,
    loadEnrollments,
    loadMoreEnrollments,
    isLoadingEnrollments,
    isLoadingMoreEnrollments,
    hasLoadedAllEnrollments,
    sort,
    filter,
    search,
    limit,
    changeSort,
    changeSearch,
    changeFilter,
    changeLimit,
  }
}
